import React from 'react';
import { Input } from '../../ui/input';
import CommonFormFields from './CommonFormFields';

/**
 * Custom Request Form - Special or unique service requests
 */
const CustomRequestForm = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <CommonFormFields formData={formData} setFormData={setFormData} />
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Your Request</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Request Title *</label>
        <Input
          value={formData.request_title || ''}
          onChange={(e) => updateField('request_title', e.target.value)}
          placeholder="Brief title for your request"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Request Description *</label>
        <textarea
          value={formData.request_description || ''}
          onChange={(e) => updateField('request_description', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[100px]"
          placeholder="Describe what you need"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Detailed Requirements *</label>
        <textarea
          value={formData.detailed_requirements || ''}
          onChange={(e) => updateField('detailed_requirements', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[100px]"
          placeholder="Specific details, expectations, constraints, etc."
          required
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Location(s)</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Primary Address *</label>
        <Input
          value={formData.primary_address || ''}
          onChange={(e) => updateField('primary_address', e.target.value)}
          placeholder="Main service location"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Secondary Address (if applicable)</label>
        <Input
          value={formData.secondary_address || ''}
          onChange={(e) => updateField('secondary_address', e.target.value)}
          placeholder="Additional location"
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Budget & Timing</h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Budget Range</label>
          <select
            value={formData.budget_range || ''}
            onChange={(e) => updateField('budget_range', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="">Select range</option>
            <option value="$0-50">$0 - $50</option>
            <option value="$50-100">$50 - $100</option>
            <option value="$100-200">$100 - $200</option>
            <option value="$200+">$200+</option>
            <option value="discuss">Discuss with provider</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Pricing Preference</label>
          <select
            value={formData.pricing_preference || 'quote'}
            onChange={(e) => updateField('pricing_preference', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="quote">Request Quote</option>
            <option value="hourly">Hourly Rate</option>
            <option value="flat_rate">Flat Rate</option>
          </select>
        </div>
      </div>
      
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.flexible_timing !== false}
          onChange={(e) => updateField('flexible_timing', e.target.checked)}
          className="w-4 h-4"
        />
        I have flexible timing
      </label>
    </div>
  );
};

export default CustomRequestForm;
